<template>
  <!-- required: a situação não se limpa. Todo item está em alguma, e o X deixaria o campo
       vazio para um valor que o fluxo exige. No filtro da listagem, que é múltiplo, o X nem
       existe — lá quem tira é o fecho de cada chip. -->
  <!-- `dot`: situação de fluxo se desenha com a bolinha, e opção de domínio com o chip — a
       forma diz a natureza do valor, e este campo serve às duas. Ver `ValueForm`. -->
  <ontos-choice-input :label="$tt('state')"
                      form="dot"
                      :value="value"
                      :options="workflow.coloredStates()"
                      :multiple="multiple"
                      :readonly="readonly"
                      required
                      :hide-label="hideLabel"
                      :outlined="outlined"
                      :dense="dense"
                      @input="$emit('input', $event)"/>
</template>
<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import ChoiceInput from "@/components/live/instance/ChoiceInput.vue";
import {EnhancedWorkflow} from "@/types/Workflow";

/**
 * O campo de situação: o ChoiceInput com as situações do fluxo no lugar das opções de um
 * domínio.
 *
 * Os dois eram componentes separados porque a cor vinha de lugares diferentes — a da opção
 * guardada no domínio, a da situação derivada da ordem. Com a situação guardando a própria
 * cor, sobrou um adaptador: traduzir fluxo em opções coloridas e dar o rótulo.
 *
 * Continua existindo como componente porque os dois hospedeiros — o formulário do item e o
 * filtro da coluna na listagem — falam em fluxo, não em lista de opções.
 *
 * Não semeia mais a situação inicial: isso é regra do modelo, não do campo, e já acontece no
 * `seedState` que o InstanceInput chama ao montar. Semear aqui exigia mutar a própria prop.
 */
@Component({
  name: 'ontos-instance-state-input',
  emits: ['input'],
  components: {'ontos-choice-input': ChoiceInput}
})
class InstanceStateInput extends Vue {
  /** Id da situação, ou lista deles no filtro múltiplo. */
  @Prop({type: [Number, Array], required: true}) readonly value!: number | number[]
  /**
   * O fluxo ENHANCED: é ele que resolve a cor de cada situação, que pode ser escolhida ou
   * automática. Receber a lista crua obrigaria cada chamador a resolver por conta própria.
   */
  @Prop({type: Object, required: true}) readonly workflow!: EnhancedWorkflow
  @Prop({type: Boolean, default: false}) readonly multiple!: boolean
  @Prop({type: Boolean, default: false}) readonly readonly!: boolean
  @Prop({type: Boolean, default: false}) readonly hideLabel!: boolean
  @Prop({type: Boolean, default: false}) readonly outlined!: boolean
  @Prop({type: Boolean, default: false}) readonly dense!: boolean
}

export default toNative(InstanceStateInput)
</script>
